import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ReactNode } from "react";

import { Row } from "../../Layout/utils";

const useStyles = makeStyles()((theme: Theme) => ({
  toolbar: {
    height: "36px",
  },
}));

export const FilterRow = ({ children }: { children?: ReactNode }) => {
  const { classes } = useStyles();
  return (
    <Row
      className={classes.toolbar}
      sx={{
        alignItems: "center",
        flex: "1",
        overflow: "hidden",
      }}
    >
      {children}
    </Row>
  );
};
